import React, { Component, Fragment } from 'react'
import style from '../Stepper/stepper.style'
import cx from 'classnames'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import EcomPixel from '../EcomPixel'
import EcomAnalytics from '../EcomAnalytics'

class Stepper extends Component {
  state = {
    pixel: window.state.pixel,
    isReadyPixel: window.state.pixel_enabled,
    isReadyGa: window.state.ecom_enabled_to_google_analytics,
  }

  updateStepper = (pixel, ga) => {
    if (pixel) {
      this.setState({
        isReadyPixel: true,
      })
    }

    if (ga) {
      this.setState({
        isReadyGa: true,
      })
    }
  }

  render() {
    const { classes, siteName, errorsEcom } = this.props
    const { pixel, isReadyPixel, isReadyGa } = this.state

    const isFinishStepper = isReadyPixel && isReadyGa
    const icon = isFinishStepper ? (
      <span
        style={{
          width: 6,
          height: 6,
          backgroundColor: 'rgb(0, 0, 0)',
          display: 'block',
          borderRadius: '100%',
        }}
      />
    ) : (
      <span
        style={{
          width: 6,
          height: 6,
          border: 'solid 1px rgba(136, 102, 255, 0.2)',
          display: 'block',
          borderRadius: '100%',
        }}
      />
    )

    const title = isFinishStepper ? (
      <Fragment>
        <span className={classes.titleFinish}>Спасибо!</span>
        <span className={classes.subTitleFinish}>
          Теперь наша очередь поработать :)
        </span>
      </Fragment>
    ) : (
      `Дождитесь письма о готовности модуля!`
    )

    return (
      <div className={classes.setting}>
        {errorsEcom && errorsEcom.length > 0 ? (
          <div
            className={classes.errorHeading}
          >{`Чтобы включить модуль, \n устраните проблемы, перечисленные ниже:`}</div>
        ) : (
          <Typography
            style={{
              marginBottom: 25,
              fontSize: 16,
              fontWeight: 'bold',
              lineHeight: 1.5,
              color: '#000000',
            }}
          >
            Для настройки модуля выполните следующие инструкции.
          </Typography>
        )}

        {errorsEcom && errorsEcom.length > 0 ? (
          <div className={classes.errorSeparator} />
        ) : null}

        <EcomPixel
          code={pixel}
          site={siteName}
          finish={isReadyPixel}
          updateData={this.updateStepper}
          errorsEcom={errorsEcom}
        />

        {errorsEcom && errorsEcom.length > 0 ? (
          <div className={classes.errorSeparator} />
        ) : null}

        <EcomAnalytics
          finish={isReadyGa}
          updateData={this.updateStepper}
          errorsEcom={errorsEcom}
        />

        {errorsEcom && errorsEcom.length > 0 ? null : (
          <div className={classes.step}>
            <div className={classes.label}>
              <span
                className={cx(classes.icon, {
                  [classes.iconFinish]: isFinishStepper,
                })}
              >
                {icon}
              </span>
              <span className={classes.title}>{title}</span>
            </div>

            <div className={classes.content}>
              <ul
                style={{
                  maxWidth: 670,
                  padding: 0,
                  margin: 0,
                  fontSize: 12,
                  color: 'rgb(0, 0, 0, .75)',
                  listStyleType: 'none',
                }}
              >
                <li>
                  В течение 24 часов мы закончим все настройки, необходимые для
                  корректной работы модуля с вашим сайтом.
                </li>
                <li>
                  В процессе проверки мы сделаем как минимум два тестовых
                  заказа, пометив их ключевым словом “ROMI center TEST”.
                </li>
                <li>Когда все будет готово – мы пришлем вам письмо!</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default style(Stepper)
